export const INCLUDED_PAPER_PAGES = 6;
export const EXTRA_PAGE_PRICE_USD = 90;

export function countExtraPages(paperPageCount: number): number {
  return Math.max(0, paperPageCount - INCLUDED_PAPER_PAGES);
}

export function extraPageChargePence(
  paperPageCount: number,
  pricePerPagePence = EXTRA_PAGE_PRICE_USD * 100,
): number {
  return countExtraPages(paperPageCount) * pricePerPagePence;
}

export function countTotalExtraPages(paperCounts: number[]): number {
  return paperCounts.reduce((sum, count) => sum + countExtraPages(count), 0);
}

export function totalExtraPageChargePence(
  paperCounts: number[],
  pricePerPagePence = EXTRA_PAGE_PRICE_USD * 100,
): number {
  return countTotalExtraPages(paperCounts) * pricePerPagePence;
}
